import type { IconProps } from './types/types';

const DecreaseIcon = (props: IconProps) => {
  const { fill = 'currentColor', ...rest } = props;
  const svgProps = { fill, ...rest };
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M14.875 14.875L6.125 6.125M14.875 14.875L14.875 7M14.875 14.875L7 14.875"
        stroke="#FF4D4F"
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default DecreaseIcon;
